export default {
  template: `
    <manager-blocks-navigation ng-if="ctrl.Authentication.user.isManager"></manager-blocks-navigation>
    <employee-blocks-navigation ng-else></employee-blocks-navigation>
  `,
  controllerAs: 'ctrl',
  controller(Authentication) {
    'ngInject';

    this.Authentication = Authentication;
  },
};
